import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { OrgTreeComponent } from './org-tree/org-tree.component';
import { OrgTreeItemComponent } from './org-tree-item/org-tree-item.component';

@NgModule({
  declarations: [OrgTreeComponent, OrgTreeItemComponent],
  imports: [CommonModule, MatTreeModule, MatCheckboxModule, MatIconModule],
  exports: [OrgTreeComponent],
})
export class OrgTreeModule {}
